/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SurveyDto } from '../../models/survey-dto';

export interface SurveyControllerFindAll$Params {
}

export function surveyControllerFindAll(http: HttpClient, rootUrl: string, params?: SurveyControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SurveyDto>>> {
  const rb = new RequestBuilder(rootUrl, surveyControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SurveyDto>>;
    })
  );
}

surveyControllerFindAll.PATH = '/api/survey';
